module.exports = __webpack_public_path__ + "img/20-about.51bd16a9.jpg";